import { createEmptyDiagramSnapshot } from 'src/containers/ProjectDiagram/types/diagram';
import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 *  Migration to add an empty `diagram` snapshot to projects with `diagram` previously set to null
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v15 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v15Projects(prevState.projects);
  }

  return nextState;
};

const v15Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    if (project.diagram) {
      projectsById[projectId] = project;
    } else {
      const diagram = createEmptyDiagramSnapshot();
      projectsById[projectId] = { ...project, diagram };
    }
  });

  return { ...prevProjectsState, projectsById };
};
